import { defineMessages } from 'react-intl'

export default defineMessages({
  deliverableTitle: {
    id: 'components.UploadTaskFilesModal.deliverableTitle',
    defaultMessage: 'Upload on behalf of voice talent',
  },
  sourceTitle: {
    id: 'components.UploadTaskFilesModal.sourceTitle',
    defaultMessage: 'Upload files',
  },
  wordCount: {
    id: 'components.UploadTaskFilesModal.wordCount',
    defaultMessage: 'Word count',
  },
  dropzone: {
    id: 'components.UploadTaskFilesModal.dropzone',
    defaultMessage: 'Drag and drop files here, or <link>click</link> to select files',
  },
  dropzoneActive: {
    id: 'components.UploadTaskFilesModal.dropzoneActive',
    defaultMessage: 'Drop the files here ...',
  },
  sideEffects: {
    id: 'components.UploadTaskFilesModal.sideEffects',
    defaultMessage: `
      <li>.pdf, .zip, .wav, .mp3, .docx, .xlsx are supported</li>
      <li>5 GB limit for each file uploaded</li>
      <li>Uploaded ZIP archives will be auto extracted</li>
    `,
  },
  fileTooLarge: {
    id: 'components.UploadTaskFilesModal.fileTooLarge',
    defaultMessage: 'Too large. Maximum file size allowed is {maxSize}.',
  },
  uploadFailed: {
    id: 'components.UploadTaskFilesModal.uploadFailed',
    defaultMessage: 'Upload failed',
  },
  uploaded: {
    id: 'components.UploadTaskFilesModal.uploaded',
    defaultMessage: '{count, plural, one {# file uploaded} other {# files uploaded}}',
  },
  submit: {
    id: 'components.UploadTaskFilesModal.submit',
    defaultMessage: 'Upload',
  },
  uploading: {
    id: 'components.UploadTaskFilesModal.uploading',
    defaultMessage: 'Uploading..',
  },
  cancel: {
    id: 'components.UploadTaskFilesModal.cancel',
    defaultMessage: 'Cancel',
  },
  close: {
    id: 'components.UploadTaskFilesModal.close',
    defaultMessage: 'Close',
  },
})
